import React from 'react';
import Navigation from '../../components/navigation'
import {Map, Marker} from 'react-bmap'
import './index.css'

export default class index extends React.Component {
    componentWillMount(){
        
    }
    render(){
        return (
            <main>
                <Navigation tab="about"></Navigation>
                <div className="about_container">
                    <p>关于门户网站</p>
                    <p>中国击剑网，是击剑运动领域门户网站，国内首家致力于传播国内外击剑新闻资讯、剑道文化礼仪、击剑专业知识、击剑教育培训以及击剑赛事信息的体育类网站。</p>
                </div>
                <div className="contact">
                    <p>联系我们</p>
                    <ul>
                        <li>联系人：中国击剑网</li>
                        <li>邮箱：fencing@188.com</li>
                        <li></li>
                    </ul>
                    <div className="address">
                        <div className="map">
                            <Map center={{lng: 120.633329, lat: 31.278005}} zoom="18">
                                {/* <div className="remark">佐罗击剑(久光百货店)</div> */}
                                <Marker position={{lng: 120.633329, lat: 31.278005}}></Marker>
                            </Map>
                        </div>
                        <div className="info">
                            <p>中国击剑网</p>
                            <div className="detail">
                                <img src={require('./../../images/address.png')}></img>
                                <div>
                                    <p>苏州市吴中区东吴北路111号东吴乐享汇二2楼</p>
                                    <p>Floor 2, lexianghui, Dongwu, No. 111, Dongwu North Road, Wuzhong District, Suzhou</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
};